var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base, makeList, VERSION } from '@or-sdk/base';
export class Discovery extends Base {
    constructor({ token, discoveryUrl }) {
        super({
            token: token,
            serviceUrl: discoveryUrl,
            serviceKey: '',
        });
        this.route = `api/${VERSION}`;
    }
    listServices() {
        return __awaiter(this, arguments, void 0, function* ({ type, feature, invalidate } = {}) {
            const { services } = yield this.callApiV2(Object.assign({ method: 'GET', route: `${this.route}/services`, params: {
                    type,
                    feature,
                } }, (invalidate ? {
                customHeaders: {
                    'Cache-Control': 'max-age=0',
                },
            } : {})));
            return makeList(services);
        });
    }
    listServicesByCategory(_a) {
        return __awaiter(this, arguments, void 0, function* ({ category, feature }) {
            const { services } = yield this.callApiV2({
                method: 'GET',
                route: `${this.route}/services-by-category`,
                params: {
                    category,
                    feature,
                },
            });
            return makeList(services);
        });
    }
    getServiceUrl(serviceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url } = yield this.callApiV2({
                method: 'GET',
                route: this.route,
                params: {
                    serviceName: serviceKey,
                },
            });
            return url;
        });
    }
    deleteService(serviceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'DELETE',
                route: `${this.route}/`,
                params: {
                    serviceKey,
                },
            });
        });
    }
    hideService(serviceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'POST',
                route: `${this.route}/hide`,
                data: {
                    serviceKey,
                },
            });
        });
    }
    revealService(serviceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callApiV2({
                method: 'POST',
                route: `${this.route}/unhide`,
                data: {
                    serviceKey,
                },
            });
        });
    }
    getServiceUrls(serviceKeys, feature) {
        return __awaiter(this, void 0, void 0, function* () {
            const { services } = yield this.callApiV2({
                method: 'GET',
                route: `${this.route}/services-by-keys`,
                params: {
                    serviceKeys,
                    feature,
                },
            });
            return serviceKeys.map((key) => {
                return services.find(service => service.serviceKey === key) || null;
            });
        });
    }
    getEnv() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                method: 'GET',
                route: `${this.route}/env`,
            });
        });
    }
    getProvidersAccountId() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.callApiV2({
                method: 'GET',
                route: `${this.route}/providersAccountId`,
            });
            return resp.providersAccountId;
        });
    }
    getCurrentAccountId() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.callApiV2({
                method: 'GET',
                route: `${this.route}/accountId`,
            });
            return resp.accountId;
        });
    }
}
//# sourceMappingURL=Discovery.js.map